import {setShowSubcontractorModal} from '../../../State/showSubcontractorModal'

export default (subcontractor) => (dispatch) => {

    dispatch(setShowSubcontractorModal({ subcontractor }))

}
